Object.defineProperty(exports,"__esModule",{value:true});var _platform=require("./../variables/platform");var _platform2=_interopRequireDefault(_platform);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}exports.default=

function(){var variables=arguments.length>0&&arguments[0]!==undefined?arguments[0]:_platform2.default;
var swipeRowTheme={
"NativeBase.ListItem":{
".list":{
backgroundColor:"#FFF"},

marginLeft:0},

"NativeBase.Left":{
flex:0,
alignSelf:null,
alignItems:null,
"NativeBase.Button":{
flex:1,
alignItems:"center",
justifyContent:"center",
alignSelf:"stretch",
borderRadius:0}},


"NativeBase.Right":{
flex:0,
alignSelf:null,
alignItems:null,
"NativeBase.Button":{
flex:1,
alignItems:"center",
justifyContent:"center",
alignSelf:"stretch",
borderRadius:0}},


"NativeBase.Button":{
flex:1,
height:null,
alignItems:"center",
justifyContent:"center",
alignSelf:"stretch",
borderRadius:0}};



return swipeRowTheme;
};
//# sourceMappingURL=SwipeRow.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/native-base/dist/src/theme/components/SwipeRow.js
// module id = 449
// module chunks = 0